/**
 * Summary-хук для досок interactions.
 * Дата: 17.03.2026
 */
import { useMemo } from 'react';
import { format } from 'date-fns';
import { useQuery } from '@tanstack/react-query';
import { interactionsApi } from '@/api/interactions';
import type { InteractionEventType } from '@/types/interaction';

// 17.03.2026 - Отдельный summary hook нужен для board-секций и будущих interaction widgets.
export function useInteractionSummary(tenantId?: string, dateFrom?: Date | null, dateTo?: Date | null) {
  const dateFromLabel = dateFrom ? format(dateFrom, 'yyyy-MM-dd') : undefined;
  const dateToLabel = dateTo ? format(dateTo, 'yyyy-MM-dd') : undefined;

  const query = useQuery({
    queryKey: ['interactions-summary', tenantId, dateFromLabel, dateToLabel],
    queryFn: () => interactionsApi.summary(tenantId as string, dateFromLabel, dateToLabel),
    enabled: !!tenantId,
  });

  const summaryMap = useMemo(() => {
    const nextMap: Record<string, number> = {};
    (query.data?.summary || []).forEach((row) => {
      nextMap[row.event_type] = (nextMap[row.event_type] || 0) + row.count;
    });
    return nextMap as Record<InteractionEventType, number>;
  }, [query.data?.summary]);

  return {
    summary: query.data?.summary || [],
    summaryMap,
    isLoading: query.isLoading,
  };
}
